import React from 'react';
import './TextBlockLink.scss';

const TextBlockLink = () => {

  return (
    <section className='ableton__textblocklink section__padding'>
      <div className="textblocklink-container">
        <p className='strong-text'>We make <span>Live</span>, <span>Push</span> and <span>Link</span> — unique software and hardware for music creation and performance. With these products, our community of users creates amazing things.</p>
        <p className='text'>Ableton was founded in 1999 and released the first version of Live in 2001. Our products are used by a community of dedicated musicians, sound designers, and artists from across the world.</p>
      </div>
    </section>
  );
};

export default TextBlockLink;